/*eslint no-unused-vars: 0*/
/*eslint @typescript-eslint/explicit-module-boundary-types: 0*/
import { AxiosError } from 'axios';
import { MessageProps } from 'Components/Common/Message';
import { useCallback } from 'react';
import { toast } from 'react-toastify';

export default function useMessage() {
  const openMessage = useCallback(
    (data: MessageProps) => toast(data.message, { type: data.variant }),
    [],
  );

  const openMessageError = useCallback((errors, defaultMsg = '') => {
    const { response } = errors as AxiosError;
    switch (response?.data.statusCode) {
      case 500:
        toast.error('サーバーエラー');
        break;
      default:
        toast.error(defaultMsg || response?.data.message[0]);
        break;
    }
  }, []);

  return { openMessage, openMessageError };
}
